import { BackspaceIcon } from './BackspaceIcon';

/**
 * author: Google
 * id 2AAC06E6-8ABD-418B-B9A4-8554B62D7C04
 * name backspace
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/backspace.svg
 * tags
 */
export const ClearIcon = BackspaceIcon;
export default ClearIcon